import styled from 'styled-components';
import { colors, MediaQuery } from '../../../../../theme/style-helpers';

export const ModalContainer = styled.div`
  width: auto;
  max-width: 600px;
`;

export const ModalTitlesContainer = styled.div`
  display: grid;
  grid-gap: 12px;
`;

export const ModalTitle = styled.div`
  font-size: 24px;
  font-weight: 500;
  line-height: 31px;
  letter-spacing: 0em;
  text-align: center;

  ${MediaQuery.small`
    font-size: 28px;
    line-height: 36px;
  `};
`;

export const ModalSubTitle = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: center;
`;

export const CategoriesContainer = styled.div`
  display: grid;
  grid-gap: 32px;
`;

export const CategoryContainer = styled.div`
  display: grid;
  grid-gap: 12px;
`;

export const BoxContainer = styled.div`
  padding: 20px 8px 20px 17px;
  background-color: ${({ bgColor }) => (bgColor || colors.WHITE)};
  max-width: ${({ maxWidth }) => maxWidth && maxWidth};
  max-height: ${({ maxHeight }) => (maxHeight || 'unset')};

  >div {
    padding-left: 3px;
    padding-top: 1px;
  }
`;

export const BoxInfo = styled.div`
  display: grid;
  grid-gap: 16px;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${colors.COOL_GREY};
    border-radius: 100px;
    background-clip: padding-box;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: ${colors.DARK_GREY};
  }
`;

export const CategoryTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0em;
`;

export const DownloadModalBody = styled.div`
  display: grid;
  justify-content: center;
  grid-gap: 20px;
  margin: 30px 0px;
`;

export const DatesContainer = styled.div`
  display: grid;
  grid-gap: 24px;
  grid-auto-flow: column;
`;

export const DatePickerWrapper = styled.div`
  min-width: 180px;
`;

export const ButtonGroup = styled.div`
  display: grid;
  grid-gap: 32px;
  justify-content: center;
  flex-wrap: wrap;

  >button:first-child {
    outline: 1px solid ${colors.BLACK};
  }

  ${MediaQuery.small`
    grid-auto-flow: column;
  `};
`;

export const ErrorMessage = styled.div`
  color: ${colors.ERROR};
  font-size: 14px;
  text-align: center;
`;
